// extracted by mini-css-extract-plugin
module.exports = {"couponImage":"HorizonCouponList_couponImage__2yyYG","list":"HorizonCouponList_list__1moco","couponBox":"HorizonCouponList_couponBox__vQK_Z"};